export default {
  showError500: (state, payload) => {
    state.active = true;
    state.options = payload;
  },

  closeError500: state => {
    state.active = false;
    state.options = {};
  }
};
